import React from 'react';
import { C } from './theme';

// ── KPI card — flat white, 3px colored left border, no shadow ──────────────────
export const kpiCardStyle = (color = C.navy) => ({
  background: '#fff', borderRadius: 8, padding: '14px 18px',
  border: `1px solid ${C.border}`, borderLeft: `3px solid ${color}`, boxShadow: 'none',
});

export function KpiCard({ label, value, color = C.navy, sub }) {
  return (
    <div style={kpiCardStyle(color)}>
      <div style={{ fontSize: 24, fontWeight: 800, color: C.text, lineHeight: 1.1 }}>{value}</div>
      <div style={{ fontSize: 12, color: C.textMuted, marginTop: 4 }}>{label}</div>
      {sub != null && sub !== '' && <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

// ── Tables — white rounded card + zebra striping ───────────────────────────────
export const tableCardStyle = { background: '#fff', borderRadius: 8, border: `1px solid ${C.border}`, overflow: 'hidden' };
export const rowBg = (i) => (i % 2 === 1 ? '#FAFAFA' : '#FFFFFF');

// ── Modals — dark header (#2D2C72) with white title ────────────────────────────
export const modalHeaderStyle = {
  background: C.sidebar, color: '#fff', padding: '14px 24px',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};
export function ModalHeader({ title, subtitle, onClose, radius = 12 }) {
  return (
    <div style={{ ...modalHeaderStyle, borderRadius: `${radius}px ${radius}px 0 0` }}>
      <div>
        <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#fff' }}>{title}</h3>
        {subtitle && <p style={{ margin: '3px 0 0', fontSize: 12, color: 'rgba(255,255,255,0.72)' }}>{subtitle}</p>}
      </div>
      {onClose && <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.85)', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}>✕</button>}
    </div>
  );
}

// ── Buttons ────────────────────────────────────────────────────────────────────
export const btnPrimary = { padding: '8px 16px', background: C.navy, color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' };
export const btnDanger = { padding: '8px 16px', background: C.red, color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: 'pointer' };

// ── Numeric line sort ────────────────────────────────────────────────────────
// line_no is a varchar ("Line 1", "Line 10") — a plain string sort puts "Line 10"
// between 1 and 2. Sort by the NUMERIC part instead (1,2,…,9,10,11); non-numeric
// names sort last, alphabetically. Works on {line_no} objects or raw strings.
export const lineNoNum = (x) => {
  const m = String((x && x.line_no != null) ? x.line_no : x ?? '').match(/\d+/);
  return m ? parseInt(m[0], 10) : Infinity;
};
export const byLineNo = (a, b) =>
  (lineNoNum(a) - lineNoNum(b)) ||
  String((a && a.line_no != null) ? a.line_no : a).localeCompare(String((b && b.line_no != null) ? b.line_no : b));

// ── List record-count footer ─────────────────────────────────────────────────
// Consistent count line for every list/table page (matches Merchandising > Orders).
//   shown = rows currently displayed (after search/filter), total = full set size.
//   noun  = item name for the page (e.g. 'estimates', 'GPOs', 'vendors').
// Renders "Showing N noun" when nothing is filtered, else "Showing X of Y noun".
export function ListFooter({ shown, total, noun = 'items' }) {
  const s = Number(shown ?? 0);
  const t = total == null ? s : Number(total);
  return (
    <div style={{ padding: '10px 16px', borderTop: '1px solid #eee', fontSize: 12, color: '#888' }}>
      {s === t ? `Showing ${s} ${noun}` : `Showing ${s} of ${t} ${noun}`}
    </div>
  );
}
